import appMock from "@/mock/application.json";
import {appIcon} from "@/types/application";

import {getDataMock} from "./_callApi";

export async function getApp(): Promise<appIcon[]> {
  if (getDataMock()) {
    const application: appIcon[] = appMock;
    return application;
  } else {
    const application: appIcon[] = appMock;
    return application;
  }
}
